import "../../styles/rangeInput.css";
import React, { Component } from "react";
import InputRange from "react-input-range";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";


// var mqtt = require("mqtt");
// var host = "ws://192.168.0.199:3000";
// var options = {
//   keepalive: 3600,
//   protocolId: "MQTT",
//   protocolVersion: 4,
//   clean: true,
//   reconnectPeriod: 1000,
//   connectTimeout: 30 * 1000,
//   will: {
//     topic: "WillMsg",
//     payload: "Connection Closed abnormally..!",
//     qos: 0,
//     retain: false,
//   },
//   username: "",
//   password: "",
//   rejectUnauthorized: false,
// };
// var mqttClient = mqtt.connect(host, options);

// const MQTT = require("async-mqtt");
// const client = MQTT.connect("tcp://192.168.0.199:3000");


const useStyles = makeStyles({
  root: {
    width: 300,
  },
});

function valuetext(value) {
  return `${value} sec`;
}

class RangeInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {
        min: 5,
        max: 10,
      },
      maxValue: null,
      minValue: null,
      unit: "",
      flag: false,
      value: [50,100],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCommitted = this.handleChangeCommitted.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (this.props.minValue !== this.state.minValue) &&
      this.state.flag == false
    ) {
      this.setState({minValue : this.props.minValue})
    }

    if (
      (this.props.maxValue !== this.state.maxValue) &&
      this.state.flag == false
    ) {
      this.setState({maxValue: this.props.maxValue})
    }
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue, flag: true });
    // let frequencyOn = newValue[1].toString()
    // mqttClient.publish(
    //   "hamk/iot/valkeakoski/kontti/ui/" + this.props.topic + "/Frequency",
    //   frequencyOn
    // );    
  };

  handleChangeCommitted = (event, newValue) => {
    // let frequencyOn = newValue[1].toString()
    // mqttClient.publish(
    //   "hamk/iot/valkeakoski/kontti/ui/" + this.props.topic,
    //   frequencyOn
    // );   
  };

  render() {
    return (
      <div
      >
        <Typography id="range-slider" gutterBottom>
          {this.props.topic == 'FeederControlFrequency' ? '(Unit: Hz - Min/Max: 0/2500)' : this.props.topic == 'PrimaryFanSpeed' ? '(Unit: % - Min/Max: 0/100)' : this.props.topic == 'BurningTemp' ? '(Unit: *C - Min/Max: 0/300)' : this.props.topic == 'WaterTemp' ? '(Unit: *C - Min/Max: 0/100)' : ''}
        </Typography>
        <Typography id="range-slider" gutterBottom>
           { this.props.topic !== 'BurningTemp' ? this.props.maxValue : this.props.maxValue}
        </Typography>
        <Slider
          color="#52af77"
          value={((this.state.maxValue !== null || this.state.minValue !== null) && this.state.flag == false ) ? [this.state.minValue, this.state.maxValue] : this.state.value}
          onChange={this.handleChange}
          valueLabelDisplay="auto"
          aria-labelledby="range-slider"
          getAriaValueText={valuetext}
          onChangeCommitted={this.handleChangeCommitted}
        />
      </div>
    );
  }
}

export default RangeInput;
